import React, {useState} from 'react';
import { Button, Popconfirm, Modal, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ClockCircleOutlined, CodeSandboxOutlined } from '@ant-design/icons';
import '../../../assets/styles/orders.scss';
import dayjs from 'dayjs';

import Price from './Price';
import Type from './Type';
import Offers from './Offers';

import * as activeOrdersConst from '../../../constants/activeOrders';

const orderTypes = {
  1: 'Оборудование',
  2: 'Стройматериалы',
  3: 'Металл',
  4: 'Продукты',
  5: 'Запчасти',
  6: 'Сырьё',
  7: 'Мебель',
  8: 'Металлопрокат',
  9: 'Трубы'
};

const deliveryStatusMap = {
  1: {
    text: 'Принят водителем',
  },
  2: {
    text: 'На погрузке',
    isWhite: true
  },
  3: {
    text: 'В пути'
  },
  4: {
    text: 'На отдыхе',
    isWhite: true
  },
  5: {
    text: 'Прибыл'
  },
  6: {
    text: 'На разгрузке'
  },
  7: {
    text: 'Завершен'
  },
  8: {
    text: 'Едет на погрузку',
    isWhite: true
  },
}


const Order = ({ order, deleteOrder, fetchList }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showOffers, setShowOffers] = useState(false);
  const navigate = useNavigate();

  const editOrder = () => {
    navigate(`/orders/${order.uuid}`);
  };

  const confirm = () => {
    deleteOrder(order);
  };

  const cancel = (e) => {
    console.log('Click on No');
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const toggleOffers = (_showOffers) => {
    setShowOffers(_showOffers);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const onAcceptOffer = () => {
    setShowOffers(false);
    fetchList();
  }

  return (
    <div className='order-item'>
      <div className='order-item__top'>
        <div className='order-item__top__date'>
          <div className='order-item__top__date__month'>
            {dayjs(order.created_at).locale('ru').format('MMMM')}
          </div>
          <div className='order-item__top__date__day'>
            {dayjs(order.created_at).locale('ru').format('DD')}
          </div>
        </div>
        <div className='order-item__top__middle'>
          <div className='order-item__top__id'>
            ID {order.uuid}
          </div>
          {order.contacts && order.contacts.contact_name &&
            <div className='order-item__top__contacts'>
              {order.contacts.contact_name}
            </div>
          }
        </div>
        {(order.status == activeOrdersConst.ACTIVE || order.status == activeOrdersConst.COMPLETED) && <div className='order-item__top__right'>
          <div className='order-item__status'>
            <Tag color={deliveryStatusMap[order.delivery_status]?.isWhite ? 'default' : 'processing'}>
              {deliveryStatusMap[order.delivery_status].text}
            </Tag>
          </div>
        </div>}
      </div>
      <div className='order-item__points order-item__points--cities' style={{marginBottom: '5px'}}>
        <div className='order-item__points__item order-item__points__item--from'>
          <div className='order-item__points__item__text'>
            { order.from_address.split(',')[0] }
          </div>
        </div>
        <div className='order-item__points__item order-item__points__item--to'>
          <div className='order-item__points__item__text'>
            { order.to_address.split(',')[0] }
          </div>
        </div>
      </div>
      <div className='order-item__points order-item__points--markers' style={{marginBottom: '5px'}}>
        <div className='order-item__points__item order-item__points__item--from'>
          <div className='order-item__points__item__icon'>
            A
          </div>
        </div>
        <div className='order-item__points__item order-item__points__item--to'>
          <div className='order-item__points__item__icon'>
            B
          </div>
        </div>
      </div>
      <div className='order-item__points order-item__points--countries' style={{marginBottom: '20px'}}>
        <div className='order-item__points__item order-item__points__item--from'>
          <div className='order-item__points__item__text'>
            { order.from_address.split(',')[1] }
          </div>
        </div>
        <div className='order-item__points__item order-item__points__item--to'>
          <div className='order-item__points__item__text'>
            { order.to_address.split(',')[1] }
          </div>
        </div>
      </div>
      <Price order={order} />
      <div className='order-item__section'>
        <div className='order-item__section__icon'>
          <ClockCircleOutlined
            style={{
              fontSize: 16,
              color: '#333'
            }}
          />
        </div>
        <div className='order-item__section__content'>
          <span>{dayjs(order.from_date).locale('ru').format('MMM DD')} - </span>
          <span>{dayjs(order.to_date).locale('ru').format('MMM DD')}</span>
        </div>
      </div>
      <Type order={order} />
      <div className='order-item__section'>
        <div className='order-item__section__icon'>
          <CodeSandboxOutlined
            style={{
              fontSize: 16,
              color: '#333'
            }}
          />
        </div>
        <div className='order-item__section__content'>
          {orderTypes[order.item.type]}
        </div>
      </div>
      <div className='order-item__controls'>
        <Button type='primary' onClick={showModal}>Показать на карте</Button>
        {+order.status === activeOrdersConst.CREATED && <Button type='default' onClick={editOrder}>Редактировать</Button>}
        {+order.status === activeOrdersConst.CREATED && <Button color="default" variant="filled" onClick={() => toggleOffers(true)}>Предложения</Button>}
        <Popconfirm
          title='Удалить ордер'
          description='Вы уверены что хотите удалить ордер?'
          onConfirm={confirm}
          onCancel={cancel}
          okText='Удалить'
          cancelText='Отмена'
        >
          <Button danger>Удалить</Button>
        </Popconfirm>
      </div>
      {/* {isModalOpen &&
      <Modal title="" footer={null} open={true} onCancel={handleCancel} classNames={{wrapper: 'from-to-map'}}>
        <Map
          latFrom={order.location_from.lat}
          lngFrom={order.location_from.lng}
          latTo={order.location_to.lat}
          lngTo={order.location_to.lng}
          order={order}
        />
      </Modal>}
      {showOffers &&
      <Modal title="" footer={null} open={true} onCancel={() => toggleOffers(false)} classNames={{wrapper: 'from-to-map'}}>
        <Offers order={order} onAcceptOffer={onAcceptOffer} />
      </Modal>} */}
    </div>
  )
};

export default Order;